<template>
    <div>
        <el-dialog title="Szczegóły pola"
                   :before-close="handleClose"
                   :visible.sync="dialogFormVisible">
            <div class="language-switcher">
                <form-language-switcher/>
            </div>
            <el-form :model="formCopy"
                     label-width="100px">
                <base-field :form.sync="formCopy"
                            :errors="errors"
                            v-if="formCopy.resourcetype !== 'TextField'"/>
                <component :is="fieldComponent"
                           :form.sync="formCopy"
                           :errors="errors"/>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelForm()">Anuluj</el-button>
                <el-button type="primary"
                           @click="submitForm()">Zatwierdź
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import BaseField from '@/components/fields/forms/BaseField'
    import {CustomForm} from '@/api'
    import availableFieldsForms from '@/components/fields/availableFieldsForms'

    export default {
        props: ["field", "bus"],
        data () {
            return {
                formCopy: {},
                originalForm: {},
                fieldComponent: null,
                errors: {},
                dialogFormVisible: false
            }
        },
        mounted () {
            this.bus.$on('openFieldDialog', this.openDialog)
        },
        methods: {
            openDialog (field, errors) {
                this.formCopy = JSON.parse(JSON.stringify(field))
                this.originalForm = field  // keep reference
                this.fieldComponent = availableFieldsForms[field.resourcetype]
                this.dialogFormVisible = true
                this.errors = errors || {}
            },
            handleClose (done) {
                const formWasChanged = JSON.stringify(this.formCopy) !== JSON.stringify(this.originalForm)
                if (formWasChanged) {
                    this.$confirm('Zmiany zostaną utracone.')
                        .then(response => {
                            done();
                        })
                        .catch(_ => {
                        });
                } else {
                    done()
                }
            },
            cancelForm () {
                this.dialogFormVisible = false
                this.$emit('cancel')
            },
            submitForm () {
                CustomForm.validateField(this.formCopy).then(response => {
                    this.$emit('submit')
                    this.originalForm = Object.assign(this.originalForm, this.formCopy)
                    this.dialogFormVisible = false
                }).catch(this.errorHandler)
            }
        },
        components: {
            BaseField
        }
    }
</script>
<style lang="scss" scoped>
    .language-switcher {
        text-align: right;
        position: relative;
        bottom: 57px;
        right: 45px;
    }
</style>


// WEBPACK FOOTER //
// FieldDialog.vue?4602ddc6